/* eslint-disable no-magic-numbers */
export const HEADER_OVERLAY_VARIANTS = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

export const HEADER_DRAWER_VARIANTS = {
  hidden: { opacity: 0, y: 100 },
  visible: {
    opacity: 1,
    y: 0,
    rotate: 0,
    transition: {
      type: 'spring',
      damping: 15,
      stiffness: 200,
      staggerChildren: 0.03,
    },
  },
  exit: {
    opacity: 0,
    y: 100,
    transition: { duration: 0.1 },
  },
};

export const HEADER_DRAWER_MENU_CONTAINER_VARIANTS = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export const HEADER_DRAWER_MENU_VARIANTS = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export const HEADER_EASING = [0.25, 0.1, 0.25, 1];
